export type KkmServerErrorCode =
  | 'bridge_missing'
  | 'cancellation_unsupported'
  | 'component_missing'
  | 'device_busy'
  | 'kkt_not_found'
  | 'malformed_response'
  | 'operation_timeout'
  | 'unsupported_mapping';

export type KkmServerOperationOutcome = 'known_not_run' | 'unknown' | 'user_cancelled';

export interface KkmServerErrorDetails {
  code: KkmServerErrorCode;
  command: string | null;
  operationId: string | null;
  outcome: KkmServerOperationOutcome;
  safeMessage: string;
}

export class KkmServerAdapterError extends Error {
  public readonly code: KkmServerErrorCode;

  public readonly command: string | null;

  public readonly operationId: string | null;

  public readonly outcome: KkmServerOperationOutcome;

  public constructor(details: KkmServerErrorDetails) {
    super(details.safeMessage);
    this.name = 'KkmServerAdapterError';
    this.code = details.code;
    this.command = details.command;
    this.operationId = details.operationId;
    this.outcome = details.outcome;
  }
}
